import React from 'react';
import { FaFilterCircleXmark } from 'react-icons/fa6';

import { RsFilter } from './RsFilter';
import { SearchAutocomplete, SearchAutocompleteItem, SelectedSearchChips } from './SearchAutocomplete';

export interface FiltersValue {
	items: SearchAutocompleteItem[];
	rs: string[];
}

export interface FiltersProps {
	value: FiltersValue;
	onChange(value: FiltersValue): void;
	middleSlot?: React.ReactNode;
	rightSlot?: React.ReactNode;
}

export function Filters({ value, onChange, middleSlot, rightSlot }: FiltersProps) {
	const isSearchActive = value.items.length > 0;
	const isRsActive = value.rs.length > 0;
	const hasActiveFilters = isSearchActive || isRsActive;

	const handleSearchChange = (items: SearchAutocompleteItem[]) => {
		onChange({ items, rs: [] });
	};

	const handleRemoveChip = (id: string) => {
		onChange({ items: value.items.filter((item) => item.id !== id), rs: [] });
	};

	return (
		<div className='space-y-3 pb-4'>
			<div className='flex flex-col gap-4 lg:flex-row lg:flex-nowrap lg:items-end'>
				<div className='min-w-0 flex-1'>
					<SearchAutocomplete selectedItems={value.items} disabled={isRsActive} onChange={handleSearchChange} />
				</div>

				<div className='flex-shrink-0 w-full lg:w-auto'>
					<RsFilter selectedRs={value.rs} disabled={isSearchActive} onChange={(rs) => onChange({ items: [], rs })} />
				</div>

				<div className='flex flex-wrap lg:flex-nowrap justify-end items-center gap-3 flex-shrink-0 lg:ml-auto'>
					<button
						type='button'
						className='flex items-center gap-1.5 h-8 px-3 rounded border border-cPurple-400 bg-white text-sm font-semibold text-cPurple-600 shadow-sm tracking-wide whitespace-nowrap flex-shrink-0 transition-colors hover:bg-cPurple-600 hover:border-cPurple-600 hover:text-white disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-cPurple-400 disabled:hover:text-cPurple-600'
						disabled={!hasActiveFilters}
						onClick={() => onChange({ items: [], rs: [] })}
					>
						Zrušit filtry
						<FaFilterCircleXmark className='w-3 h-3 flex-shrink-0' />
					</button>
					{middleSlot}
					{rightSlot}
				</div>
			</div>

			{isRsActive ? <p className='text-xs text-gray-400'>Nelze kombinovat s filtrem Referenční skupina (RS)</p> : null}
			{isSearchActive ? <p className='text-xs text-gray-400'>Nelze kombinovat s vyhledáváním</p> : null}

			{value.items.length > 0 ? <SelectedSearchChips items={value.items} onRemove={handleRemoveChip} /> : null}
		</div>
	);
}
